export const DELIVERY = "DELIVERY"
export const LOCAL = "RETIRO"
export const RETIRO = "LOCAL"
export const RESTAURANT = "RESTAURANT"